import logger from '../utils/logger';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;

if (!supabaseUrl) {
  logger.warn(
    'Missing Supabase URL environment variable. Set REACT_APP_SUPABASE_URL.'
  );
}

// NOTA: La autenticación de Supabase ahora se maneja desde el backend
// para mayor seguridad. Este cliente solo se usa para operaciones públicas.
const supabase = supabaseUrl
  ? createClient(supabaseUrl, 'dummy-key') // Clave dummy, no se usa para autenticación
  : null;

export default supabase;
